import {ReactElement} from "react";
import { StatKeyMap } from "../../../../utils/game/mechanics/StatKeyMap";

import Flexbox from "../../../../common/components/layout/Flexbox/Flexbox";
import Icon from "../../../../common/components/Icon/Icon";
import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import Tooltip from "../../../../common/components/wrappers/Tooltip/Tooltip";

import "./AttributeIconPanel_style.css";

type Props = Readonly<{
    statBoard: StatBoard;
    statKey: string;
    qualifiers?: Array<string> | null,
    icon?: string;
    onIconClick?: () => void;
}>

export default function AttributeIconPanel({statBoard, statKey, qualifiers = null, icon, onIconClick}: Props): ReactElement {
    const score = statBoard.getValueByStatKey(statKey, qualifiers);
    const scoreTips = statBoard.getTipsByStatKey(statKey, qualifiers, null, true);
    const statString = StatKeyMap.get(statKey) ?? statKey;

    return <Flexbox className="attribute-icon-panel" direction="row" gap={12} >
        {icon == null ? 
            null : 
            <Tooltip
                tooltipContent={statString}
                enabled={statString.length > 0}
                direction="auto-above-below"
            >
                <div className="icon-container">
                    <Icon src={icon} size={24} onClick={onIconClick} style={{cursor: onIconClick == null ? undefined : "pointer"}} />
                </div>
            </Tooltip>
        }
        <Tooltip tooltipContent={scoreTips} enabled={scoreTips.length > 0} direction="auto-above-below">
            <div className="score-container">
                <div className="score">{score}</div>
            </div>
        </Tooltip>
    </Flexbox>;
}